module.exports = __webpack_public_path__ + "static/Orbica NZ Animation-2bfd185d0c922857d4f665b19d06ac4e.mp4";